import axios from 'axios';

export const areaFetch = () => {
    return (dispatch) => {
        dispatch({ type: "AREALOADER", response: true });
        axios({
            method: "get",
            headers: {"arixauth" : localStorage.getItem("arixauth")},
            url: `${process.env.REACT_APP_APIURL}/tenant/getareas`,
          })
            .then((response) => {
                dispatch({ type: "GET_AREADATA", response: response.data });
            })
            .catch((error) => {
                console.log("ERROR area fetch ")
                dispatch({ type: "AREAFAIL", response: false });
              
            })
    }
}

export const featureFetch = () => {
    return (dispatch) => {
        
        dispatch({ type: "FEATURELOADER", response: true });
        axios({
            method: "get",
            headers: {"arixauth" : localStorage.getItem("arixauth")},
            url: `${process.env.REACT_APP_APIURL}/tenant/getfeature`,
          })
            .then((response) => {
                
                dispatch({ type: "GET_FEATURELOADER", response: response.data });
            })
            .catch((error) => {
                
                dispatch({ type: "FEATUREFAIL", response: false });
              
            })
    }
}

export const profileFetch = (tid) => async dispatch =>  {

        dispatch({ type: "PROFILELOADER", response: true });
            
        axios({
            method: "get",
            headers: {"arixauth" : localStorage.getItem("arixauth") },
            url: `${process.env.REACT_APP_APIURL}/ten/getprofile/${tid}`,
          })
            .then((response) => {
                
                dispatch({ type: "GET_PROFILEDATA", response: response.data });
            })
            .catch((error) => {
                console.log(error)
                dispatch({ type: "PROFILEFAIL", response: false });
                
              
            })

}